import "./index.scss";
import "moment/locale/pt-br";

import { Calendar, momentLocalizer } from "react-big-calendar";
import React, { Component } from "react";
import {
  getCalendarData,
  updateSelectedCalendar
} from "../../actions/dataActions";

import Loading from "../Loading";
import PropTypes from "prop-types";
import Title from "../Title";
import { changeMenu } from "../../actions/themeActions";
import { connect } from "react-redux";
import moment from "moment";

// import "react-big-calendar/lib/css/react-big-calendar.css";

moment.locale("pt-br");
const localizer = momentLocalizer(moment);

const messages = {
  allDay: "Dia todo",
  previous: "Anterior",
  next: "Próximo",
  today: "Hoje",
  month: "Mês",
  week: "Semana",
  day: "Dia",
  agenda: "Agenda",
  date: "Data",
  time: "Hora",
  event: "Evento",
  showMore: total => `+ ${total} eventos`
};

class index extends Component {
  updateSelectedCalendar = e => {
    this.props.updateSelectedCalendar(e.target.innerText);
  };

  componentDidMount() {
    this.props.changeMenu(this.props.location.pathname.slice(1));
    this.props.getCalendarData();
  }

  render() {
    const {
      theme,
      showMenu,
      loadingCalendarData,
      calendar,
      selectedCalendar
    } = this.props;

    return (
      <div id="Calendars" className={showMenu ? `blur ${theme}` : `${theme}`}>
        <div className={`title-container ${theme}`}>
          <Title text={`Agendas`} type={`SECTION`} theme={theme} />
          <span> - </span>
          <span
            onClick={this.updateSelectedCalendar}
            className={
              selectedCalendar === "STI"
                ? "calendar-type active"
                : "calendar-type"
            }
          >
            STI
          </span>
          <span
            onClick={this.updateSelectedCalendar}
            className={
              selectedCalendar === "CI"
                ? "calendar-type active"
                : "calendar-type"
            }
          >
            CI
          </span>
          <span
            onClick={this.updateSelectedCalendar}
            className={
              selectedCalendar === "CS"
                ? "calendar-type active"
                : "calendar-type"
            }
          >
            CS
          </span>
        </div>
        {loadingCalendarData ? (
          <Loading />
        ) : (
          <Calendar
            localizer={localizer}
            defaultDate={new Date()}
            defaultView="agenda"
            events={
              selectedCalendar === "STI"
                ? calendar.sti
                : selectedCalendar === "CI"
                ? calendar.ci
                : selectedCalendar === "CS"
                ? calendar.cs
                : null
            }
            style={{ minHeight: "80vh" }}
            messages={messages}
          />
        )}
      </div>
    );
  }
}

index.propTypes = {
  theme: PropTypes.string.isRequired,
  showMenu: PropTypes.bool.isRequired,
  changeMenu: PropTypes.func.isRequired,
  getCalendarData: PropTypes.func.isRequired,
  loadingCalendarData: PropTypes.bool.isRequired,
  calendar: PropTypes.object.isRequired,
  selectedCalendar: PropTypes.string.isRequired,
  updateSelectedCalendar: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  theme: state.theme.theme,
  showMenu: state.theme.showMenu,
  loadingCalendarData: state.data.loadingCalendarData,
  calendar: state.data.calendar,
  selectedCalendar: state.data.selectedCalendar
});

export default connect(mapStateToProps, {
  changeMenu,
  getCalendarData,
  updateSelectedCalendar
})(index);
